import lrTenantCompany from './_src/lrTenantCompany.vue'
lrTenantCompany.install = function(Vue) {
  Vue.component(lrTenantCompany.name, lrTenantCompany)
}

export default lrTenantCompany